import React, { useState } from 'react';
import { IAppContextState } from './app-context.types';
import { AppContext } from './AppContext';

const AppContextProvider: React.FC = ({ children }) => {
  const initialState: IAppContextState = {
    showLiveChatWidget: false,
  };

  const [state, setState] = useState<IAppContextState>(initialState);

  const setShowLiveChatWidget = (bool: boolean) => {
    modifyState('showLiveChatWidget', bool);
  };

  const modifyState = (field: string, value: any) => {
    setState((prevState) => {
      return { ...prevState, [field]: value };
    });
  };

  return (
    <AppContext.Provider
      value={{
        ...state,
        setShowLiveChatWidget,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContextProvider };
